const payrollTable = {
  columns: {
    getColumnsData: 'payrollColumnsData',
    setColumnsData: 'setPayrollColumnsData'
  },
  rows: {
    getRowsData: 'payrollRowsData',
    setRowsData: 'setPayrollRowsData'
  }
}

const payrollTableColumns = [
  {
    id: 1,
    title: 'EMPLOYEE NAME',
    property: 'employeeName',
    inputs: ['amountAED'],
    capitalize: true,
    editable: true,
    sortByColumn: true,
    typeEditable: 'select',
    listName: 'usersList',
    list: [],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 2,
    title: 'DATE OF PAYMENT',
    property: 'dateOfPayment',
    inputs: ['amountAED'],
    editable: true,
    type: 'date',
    typeEditable: 'datePicker',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 3,
    title: 'MODE OF PAYMENT',
    property: 'modeOfPayment',
    inputs: ['amountAED'],
    editable: true,
    typeEditable: 'select',
    listName: 'expensesCategories',
    list: [],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 4,
    title: 'TYPE OF PAYMENT',
    property: 'typeOfPayment',
    inputs: ['amountAED'],
    editable: true,
    sortByColumn: true,
    typeEditable: 'select',
    listName: 'typeOfPaymentList',
    list: [],
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 5,
    title: 'DESCRIPTION',
    property: 'description',
    inputs: ['amountAED'],
    editable: true,
    type: 'date',
    typeEditable: 'datePickerRange',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 6,
    title: 'AMOUNT, AED',
    property: 'amountAED',
    inputs: ['amountAED'],
    editable: true,
    typeTable: 'payroll',
    typeEditable: 'inputNumber',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 7,
    title: 'FUND',
    inputs: ['amountAED'],
    property: 'funds',
    editable: true,
    typeEditable: 'select',
    listName: 'fundList',
    list: [],
    placeholder: 'Fund',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    id: 8,
    property: 'action',
    inputs: ['amountAED'],
    actions: {
      edit: true,
      delete: true
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false,
      upload: true
    }
  }
]

export {payrollTable, payrollTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/payrollTable.js